import { func_validation, getTotalCountFromHeader } from 'functions';
import { useEffect, useState } from 'react';

export function useTableData(props) {
    const {
        billingSetup,
        billingSetupHeaders
    } = props;

    const [tableData, setTableData] = useState([]);

    function updateTableData() {
        if (func_validation.isArray(billingSetup)) {
            
            let tableData_new = [];
            for (let i = 0; i < billingSetup.length; i++) {
                let billingSetupItem = func_validation.cloneObject(billingSetup[i]);
                let billingSetupDetails = func_validation.getObjectPropertyValue(billingSetupItem, "BillingSetupDetails");
                let totalReferenceValues = func_validation.getArrayLength(billingSetupDetails);

                // Add subrow property if available
                if (totalReferenceValues && (totalReferenceValues > 0)) {
                    let chargeMethod = func_validation.getObjectPropertyValue(billingSetupItem, "ChargeMethod");

                    billingSetupItem["referenceValues"] = (totalReferenceValues > 0)? totalReferenceValues: "";

                    // Get refernce values
                    let referenceValues = "";
                    if (func_validation.isArrayNotEmpty(billingSetupDetails)) {
                        billingSetupDetails.map((detail) => {
                            let referenceValue = func_validation.getObjectPropertyValue(detail, "ReferenceValue", "");

                            if (func_validation.isStringTrimNotEmpty(referenceValue)) {
                                if (func_validation.isStringTrimEmpty(referenceValues))
                                    referenceValues = referenceValue;
                                else referenceValues += "\n" + referenceValue;
                            }
                        });
                    }

                    if (func_validation.isStringTrimNotEmpty(referenceValues)) {
                        billingSetupItem["subRows"] = [{ referenceValues: referenceValues }];
                    }

                }
                
                // Add to new table data
                tableData_new.push(billingSetupItem);
            }

            setTableData(tableData_new);
        }
    }
    useEffect(() => {
        updateTableData();
    }, [JSON.stringify(billingSetup)]);

    let masterSet = true;

    return {
        masterSet,
        tableData,
        totalRecords: getTotalCountFromHeader(billingSetupHeaders)
    }
}